module.exports = __webpack_public_path__ + "vi_VN.json";


// WEBPACK FOOTER //
// ./src/vi_VN.json